// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.month-select {
  display: inline-flex;
  gap: 16px;
  align-items: center;
}
.month-select .pagination-btn {
  display: inline-flex;
  font-size: 14px;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  height: 36px;
}
.month-select .selected-date {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-left: 4px;
  color: var(--Primary-600, #7f56d9);
}

.calendar-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 100%;
  padding-top: 30px;
}
.calendar-container .day-name {
  color: #667085;
  font-size: 16px;
  line-height: 21px;
  font-weight: 400;
  text-align: right;
  margin-bottom: 10px;
}
.calendar-container .calendar-day {
  height: 185px;
  border: 1px solid #eaecf0;
  border-top: none;
  padding: 10px;
  overflow-y: auto;
}
.calendar-container .calendar-day.row-0 {
  border-top: 1px solid #eaecf0 !important;
}
.calendar-container .calendar-day-0, .calendar-container .calendar-day-1, .calendar-container .calendar-day-2, .calendar-container .calendar-day-3, .calendar-container .calendar-day-4, .calendar-container .calendar-day-5 {
  border-right: none;
}
.calendar-container .calendar-day-0, .calendar-container .calendar-day-6 {
  background-color: #f9fafb;
}
.calendar-container .calendar-day .day-number {
  font-size: 18px;
  line-height: 20px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  margin-bottom: 8px;
}
.calendar-container .calendar-day .day-number > div {
  padding: 2px 8px;
  border-radius: 16px;
  line-height: 20px;
  display: inline;
}
.calendar-container .calendar-day .day-number.active div {
  background-color: #7f56d9;
  color: #fff;
}
.calendar-container .calendar-day .slots-list .slots-list-item {
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 4px;
  padding: 6px 4px;
  cursor: pointer;
}
.calendar-container .calendar-day .slots-list .slots-list-item:hover {
  opacity: 0.8;
}
.calendar-container .calendar-day .slots-list .slots-list-item .slots-list-item-name {
  color: #101828;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.calendar-container .calendar-day .slots-list .slots-list-item .slots-list-item-time {
  color: #667085;
  white-space: nowrap;
}
.calendar-container .calendar-day .slots-list .slots-list-item.free {
  background-color: #f1f3f4;
}
.calendar-container .calendar-day .slots-list .slots-list-item.booked {
  background-color: #f4ebff;
}
.calendar-container .calendar-day .slots-list .slots-list-item.booked .slots-list-item-name {
  color: #7f56d9;
}`, "",{"version":3,"sources":["webpack://./src/pages/schedule/components/ScheduleTab/styles.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,kCAAA;AADJ;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,WAAA;EACA,iBAAA;AAFF;AAIE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAHJ;AAII;EACE,wCAAA;AAFN;AAKI;EAME,kBAAA;AARN;AAWI;EAEE,yBAAA;AAVN;AAaI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,2BAAA;EACA,kBAAA;AAXN;AAaM;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAXR;AAeQ;EACE,yBAAA;EACA,WAAA;AAbV;AAmBM;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAjBR;AAmBQ;EACE,YAAA;AAjBV;AAoBQ;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAlBV;AAqBQ;EACE,cAAA;EACA,mBAAA;AAnBV;AAsBQ;EACE,yBAAA;AApBV;AAuBQ;EACE,yBAAA;AArBV;AAuBU;EACE,cAAA;AArBZ","sourcesContent":[".month-select {\n  display: inline-flex;\n  gap: 16px;\n  align-items: center;\n\n  .pagination-btn {\n    display: inline-flex;\n    font-size: 14px;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 14px;\n    height: 36px;\n  }\n\n  .selected-date {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    margin-left: 4px;\n\n    color: var(--Primary-600, #7f56d9);\n  }\n}\n\n.calendar-container {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  width: 100%;\n  padding-top: 30px;\n\n  .day-name {\n    color: #667085;\n    font-size: 16px;\n    line-height: 21px;\n    font-weight: 400;\n    text-align: right;\n    margin-bottom: 10px;\n  }\n\n  .calendar-day {\n    height: 185px;\n    border: 1px solid #eaecf0;\n    border-top: none;\n    padding: 10px;\n    overflow-y: auto;\n    &.row-0 {\n      border-top: 1px solid #eaecf0 !important;\n    }\n\n    &-0,\n    &-1,\n    &-2,\n    &-3,\n    &-4,\n    &-5 {\n      border-right: none;\n    }\n\n    &-0,\n    &-6 {\n      background-color: #f9fafb;\n    }\n\n    .day-number {\n      font-size: 18px;\n      line-height: 20px;\n      font-weight: 500;\n      display: flex;\n      justify-content: space-between;\n      flex-direction: row-reverse;\n      margin-bottom: 8px;\n\n      & > div {\n        padding: 2px 8px;\n        border-radius: 16px;\n        line-height: 20px;\n        display: inline;\n      }\n\n      &.active {\n        div {\n          background-color: #7f56d9;\n          color: #fff;\n        }\n      }\n    }\n\n    .slots-list {\n      .slots-list-item {\n        display: flex;\n        justify-content: space-between;\n        border-radius: 4px;\n        font-size: 12px;\n        margin-top: 4px;\n        padding: 6px 4px;\n        cursor: pointer;\n\n        &:hover {\n          opacity: 0.8;\n        }\n\n        .slots-list-item-name {\n          color: #101828;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          overflow: hidden;\n        }\n\n        .slots-list-item-time {\n          color: #667085;\n          white-space: nowrap;\n        }\n\n        &.free {\n          background-color: #f1f3f4;\n        }\n\n        &.booked {\n          background-color: #f4ebff;\n\n          .slots-list-item-name {\n            color: #7f56d9;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
